import { render, staticRenderFns } from "./WorkflowClp.vue?vue&type=template&id=369f8eb2"
import script from "./WorkflowClp.vue?vue&type=script&lang=js"
export * from "./WorkflowClp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports